import React from 'react';
import Menu from '../components/Menu';
import { useSelector, useDispatch } from 'react-redux';
import{ login, setOrgId, setApiKey, setDeviceId } from '../store/AuthStore';

const Login = () => {
    const dispatch = useDispatch();
    const authState = useSelector((state) => state[AuthStore.reducerName]); 

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(login());
        navigate('/');
    };

    const handleOrgIdChange = (e) => {
        dispatch(setOrgId(e.target.value)); 
    };

    const handleApiKeyChange = (e) => {
        dispatch(setApiKey(e.target.value)); 
    };

    const handleDeviceIdChange = (e) => {
        dispatch(setDeviceId(e.target.value)); 
    };

    return (
        <div className="App">
            <Menu />
            <div className="login">
                <form onSubmit={handleLogin}>
                    <label>OrganizationId</label>
                    <input
                        type="text"
                        placeholder="Id"
                        value={authState.orgId}
                        onChange={handleOrgIdChange}
                    />
                    <label>ApiKey</label>
                    <input
                        type="password"
                        placeholder="Api-key"
                        value={authState.apiKey}
                        onChange={handleApiKeyChange}
                    />
                    <label>DeviceId</label>
                    <input
                        type="text"
                        placeholder="Device-Id"
                        value={authState.deviceId}
                        onChange={handleDeviceIdChange}
                    />
                    <input type="submit" className="btn" value="login" />
                </form>
            </div>
        </div>
    );
};

export default Login;